module.exports = __webpack_public_path__ + "img/logoDSC.6cc4dbcb.png";